module.exports = __webpack_public_path__ + "img/burkina-faso.3f544e00.svg";